<div [class]="theme">
  <div edsGrid>
    <div
      [class]="colsPerGridForDesktop === 3 ? 'container--wide' : 'container'"
    >
      <div edsRow>
        <ft-intro-section
          edsCol
          [showCta]="content?.cards?.length > 0 ? false : true"
          [content]="content"
          [titleColorTheme]="titleColorTheme"
        ></ft-intro-section>
      </div>
      <div edsRow>
        <div edsCol>
          <ng-container *ngIf="isHandheld$ | async; else desktop">
            <ng-container *ngTemplateOutlet="twoColdGrid"></ng-container>
          </ng-container>
          <ng-template #desktop>
            <ng-container
              *ngIf="colsPerGridForDesktop === 2; else threeColdGrid"
            >
              <ng-container *ngTemplateOutlet="twoColdGrid"></ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
      <!-- </ng-container> -->
    </div>
  </div>
</div>

<ng-template #twoColdGrid>
  <div
    edsSubGrid="layout-1"
    edsSubGridTabletGap="lg"
    edsSubGridTablet="layout-1"
    edsSubGridGap="lg"
    edsSubGridRowGap="lg"
  >
    <ng-container *ngTemplateOutlet="thumbnail"></ng-container>
  </div>
</ng-template>

<ng-template #threeColdGrid>
  <div
    edsSubGrid="layout-2"
    edsSubGridTabletGap="lg"
    edsSubGridTablet="layout-1"
    edsSubGridGap="lg"
    edsSubGridRowGap="lg"
  >
    <ng-container *ngTemplateOutlet="thumbnail"> </ng-container>
  </div>
</ng-template>
<ng-template #thumbnail>
  <eds-thumbnail
    *ngFor="let card of cards"
    [eventId]="card.eventId"
    [eventParams]="card.eventParams"
    [hasBorders]="true"
    [hasShadows]="true"
    [headingLevel]="2"
    [layoutSearch]="false"
    [layoutCompact]="sectionType === 'thumbnail_cards_compact'"
    [title]="card.title"
    [body]="card.content"
    [buttonText]="card.link?.displayText"
    [previewSrc]="
      sectionType === 'thumbnail_cards_compact' ? null : card.imgSrc
    "
    [docTypeSrc]="card.docTypeSrc"
    [href]="card.href"
    [titleLink]="card.href"
    [isNewWindow]="card.link?.target === '_blank'"
    [signInRequired]="card.link?.signInLink | ftIsSignInRequired | async"
    [hideLockIcon]="card.link?.hideLockIcon"
    [signInTooltip]="'common.locked-link-tooltip' | translate"
    [externalLink]="card.link?.external"
    [trackDownloads]="card.link?.enableDownloadTracking"
    [trackImpression]="card.link?.enableImpressionTracking"
  >
  </eds-thumbnail>
</ng-template>
